'use strict';

import angular from 'angular';

export default class SignupController {
  user = {};
  errors = {};
  submitted = false;

  /*@ngInject*/
  constructor(Auth, $state, $stateParams, $http, $scope, Signup, $uibModal) {
    this.Auth = Auth;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.patientDOB;
    this.$scope = $scope;
    this.Signup = Signup;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    //Differentiate based on the states
    if (this.$state.current.name == 'staffSignup') {
      console.log('The current state is staffSignup');
      this.fetchStaffMemberData();
    }
    else {
      console.log('The current state is signup');
      this.fetchPatientData();
    }
  }

  fetchPatientData = () => {
    console.log('fetching single patient data..');        //for better presentation
    // console.log(this.$stateParams.id);                    //for the testing purpose
    this.$http.get('/api/users/' + this.$stateParams.id + '/signup/')

      .then(response => {
        // console.log('patirntData -> ', response.data);

        this.user.firstName = response.data.patient.firstName;
        this.user.lastName = response.data.patient.lastName;
        this.user.email = response.data.patient.email;
        this.user.phone = parseInt(response.data.patient.phone);
        this.patientDOB = new Date(response.data.patient.dob);
      })
      .catch(error => {
        this.$state.go('signupError');

        /*
                $scope.thisCanBeusedInsideNgBindHtml =
        */
      });
  }

  fetchStaffMemberData = () => {
    console.log('fetching single physician data..');        //for better presentation
    // console.log(this.$stateParams.id);                    //for the testing purpose
    this.$http.get('/api/users/' + this.$stateParams.id + '/staffSignup/')

      .then(response => {
        // console.log(response.data);
        this.user.firstName = response.data.firstName;
        this.user.lastName = response.data.lastName;
        this.user.email = response.data.email;
        this.user.staffRole = response.data.staffRole;
      })
      .catch(error => {
        this.$state.go('signupError');
      });
  }

  register(form) {
    //    let formattedDate;
    //    formattedDate = this.user.dob.split('/').reverse().join('-');
    //    console.log("Checking DOB String: " + this.user.dob);
    this.errors = []
    //length check
    if (this.user.password.length < 8) {
      this.errors.push('The password length is less than 8');
      return
    }
    //Upper Case letter check
    if (this.user.password.search(/[A-Z]/) < 0) {
      this.errors.push('The password must contain one UpperCase Letter');
      return
    }
    //Lower Case letter check
    if (this.user.password.search(/[a-z]/) < 0) {
      this.errors.push('The password must contain one LowerCase Letter');
      return
    }
    //Letter check
    if (this.user.password.search(/[a-z]/i) < 0) {
      this.errors.push('The password must contain at least one Letter');
      return
    }
    //Digit check
    if (this.user.password.search(/[0-9]/) < 0) {
      this.errors.push('The password must contain at least one digit');
      return
    }
    //Confirm Password Check
    if (this.user.password != this.user.confirmPassword) {
      this.errors.push('The passwords do not match');
      return 
    }

    var checkDate = new Date(this.user.dob);
    this.submitted = true;
    if (form.$valid) {
      if (form.hasOwnProperty('staffRole')) {
        if (this.user.phone) {
          this.sendPhoneCode()
        }
        else {
          this.registerStaffMember()
        }
      }
      else {
        if (checkDate.getYear() != this.patientDOB.getYear() || checkDate.getMonth() != this.patientDOB.getMonth() || checkDate.getDate() != this.patientDOB.getDate()) {
          this.errors = ['Please re-enter your birth date. If problem persists, please contact your doctor\'s office.'];
        }
        this.registerUser()
        // if (this.user.phone) {
        //   this.sendPhoneCode()
        // }
        // else {
        //   this.registerUser()
        // }
      }
    }
  }

  registerStaffMember() {
    return this.Auth.createStaffMember({
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      staffRole: this.user.staffRole,
      email: this.user.email,
      phone: this.user.phone,
      isVerfiedPhone: this.user.isVerfiedPhone,
      password: this.user.password,
      confirmPassword: this.user.confirmPassword
    })
      .then((response) => {
        this.$state.go('procedureStatus');
      })
      .catch(err => {
        err = err.data;
        this.errors = err;
        console.log(this.errors);
      });
  }

  registerUser() {
    return this.Auth.createUser({
      firstName: this.user.firstName,
      lastName: this.user.lastName,
      email: this.user.email,
      phone: this.user.phone,
      password: this.user.password,
      confirmPassword: this.user.confirmPassword
    })
      .then(() => {
        // Account created, redirect to procedure status
        this.$state.go('procedureStatus');
      })
      .catch(err => {
        err = err.data;
        this.errors = err;
        console.log(this.errors);
      });
  }

  sendPhoneCode() {
    return this.Auth.sendPhoneCode({
      email: this.user.email,
      phone: this.user.phone
    })
      .then((response) => {
        // console.log('sendPhoneCode-------', response)
        this.user.phoneVerificationCode = response.phoneVerificationCode
        this.openModal({id: response._id, code: response.phoneVerificationCode})
      })
      .catch(err => {
        err = err.data;
        this.errors = err;
        console.log(this.errors);
      });
  }

  openModal = (data) => {
    let template = require('../../../components/user-modification-modal/phone-verification-model.html')

    var modalInstance = this.$uibModal.open({
      //      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: template,
      controller: 'UserModificationModalController',
      controllerAs: 'vm',
      //      size: size,
      //      appendTo: parentElem,
      resolve: {
        editUser: () => {
          return data
        }
      }
    });

    modalInstance.result.then(() => {
      console.log('Verify successful.');
      this.user.isVerfiedPhone = true
      if (this.$state.current.name == 'signup') {
        this.registerUser()
      }
      else {
        this.registerStaffMember()
      }
    }, function () {
      console.log('Modify User Modal dismissed.');
    })
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js